import React,{useState} from 'react';
import UserContext from "../../Context/AppContext";
import realtimeDB from "../../Utils/api";
import {getDate} from "../../Utils/Dates";
import styled from "styled-components";
import { Dialog,DialogContent,Button, CircularProgress } from '@material-ui/core';
import Input from "../Input";
import axios from 'axios';
import Alert from '../Alert';

const StyledForm=styled.form`
display:grid;
grid-template-columns:auto auto;

@media screen and (max-width:428px)
{
    grid-template-columns:auto;
}`;

const ContainerButton=styled.div`
margin:20px;
padding:10px;
display:grid;
grid-gap:15px;
grid-template-columns:1fr 1fr;

    
@media screen and (max-width:428px)
{
    grid-template-columns:auto;
}
`;

const AddCostumerModal=({open,close})=>
{
    const [Nombre, setNombre] = useState("");
    const [Telefono, setTelefono] = useState("");
    const [Cantidad, setCantidad] = useState("");
    const [Nota, setNota] = useState("");

    const [isLoading, setisLoading] = useState(false);

    
    const [MensajeAlerta, setMensajeAlerta] = useState(undefined);
    const [AlertaTipo, setAlertaTipo] = useState(undefined);

    const Submit=async (withWhatsapp)=>
    {
        setisLoading(true);
        const id=Date.now();
        const Cliente={id,date:getDate(),dinersCount:Cantidad,status:"annotated",name:Nombre,note:Nota,phone:Number(`549${Telefono}`),letter:""};

        try
        {
            await window.axios.post(`/customer/?Whatsapp=${withWhatsapp}`,Cliente);
            
            setMensajeAlerta(`Whatsapp enviado a ${Nombre}`);
            setAlertaTipo("success");

            setNombre("");
            setTelefono("");
            setCantidad("");
            setNota("");
            close();
        }
        catch(error)
        {
            if(error.response)
            {
                setMensajeAlerta(error.response.data.msg);
                setAlertaTipo("error");
            }
        }

        setisLoading(false);
   

    }


    let ButtonsDisabled=(Nombre==="" || Telefono=="" || Cantidad==="" || Number(Cantidad)<=0 || Number(Telefono) <=0 || String(Telefono).length!==10 );

    return <>
    <Alert type={AlertaTipo} mensaje={MensajeAlerta} close={() => setMensajeAlerta("")}/>
    <Dialog open={open} onClose={close}>
        <DialogContent>
            <StyledForm>
                <Input label="Nombre" value={Nombre} changeValue={setNombre}/>
                <Input label="Télefono" type="number"  value={Telefono} changeValue={setTelefono}/>
                <Input label="Cantidad"  type="number" value={Cantidad} changeValue={setCantidad}/>
                <Input label="Nota"  value={Nota} changeValue={setNota}/>
            </StyledForm>
            </DialogContent>
           
            <ContainerButton>
                {isLoading ? <Button><CircularProgress size={24}/></Button> : <Button onClick={() => Submit(true)} disabled={ButtonsDisabled} style={{marginLeft:"5px"}} color="primary" variant="contained">Añadir y enviar link</Button>  }
                {isLoading ? <Button><CircularProgress size={24}/></Button> : <Button onClick={() => Submit(false)} disabled={ButtonsDisabled} style={{marginRight:"5px"}} color="primary" variant="contained">Añadir sin enviar link</Button>   }
                {isLoading ? <Button><CircularProgress size={24}/></Button> : <Button style={{margin:"0 5px",gridColumn:"1/3"}} color="primary" variant="outlined" onClick={close}>Cerrar</Button>   }
            </ContainerButton>
    </Dialog>
    </>
}

export default AddCostumerModal;
